// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackModal-cls1_Se5","cls2":"FeedbackModal-cls2_MJO FeedbackModal-cls1_Se5"};